import {
	CheckoutAssociatedCardResponseRule,
	CheckoutVaultedCardCreationRule,
} from '../interfaces/checkout-credit-card.interface';

export const checkoutAssociatedCardResponseRule: CheckoutAssociatedCardResponseRule = context => {
	if (!context.response?.id || !context.response?.cardAccount?.token) {
		throw new Error('Invalid customer data response');
	}

	return context;
};

export const checkoutAssociatedCardResponseNormalizationRule: CheckoutAssociatedCardResponseRule = context => {
	const normalizedResponse = {
		id: context.response.id,
		cardAccount: {
			token: context.response.cardAccount.token,
			hasContract: context.response.cardAccount.hasContract || false,
		},
	};

	return {
		...context,
		normalizedResponse,
		vaultedCardRequest: context.customerMerchId
			? {
					vaultedCardToken: normalizedResponse.cardAccount.token,
					customerMerchId: context.customerMerchId,
				}
			: null,
	};
};

export const checkoutVaultedCardCreationSuccessRule: CheckoutVaultedCardCreationRule = context => {
	if (context.response.success !== true) {
		throw new Error('Failed to create vaulted card');
	}

	return context;
};

export const checkoutVaultedCardCreationDataRule: CheckoutVaultedCardCreationRule = context => {
	if (!context.response.data?.idVaultedCard || !context.response.data?.vaultedCardToken) {
		throw new Error('Vaulted card creation returned invalid card data');
	}

	return context;
};
